import PdfGenerator from './PdfGenerator';
import Moment from 'moment';

class Movimenti extends PdfGenerator {

    constructor(){
        super();
        this.doDrawCell = this.doDrawCell.bind(this);
        this.doDrawRow = this.doDrawRow.bind(this);
    }

    doDrawCell(cell, data){
        if (data.row.raw.id === '' && (data.row.raw.data ==='TP' || data.row.raw.data ==='TF')){
            if (data.column.dataKey === 'data'){
                cell.text = '';
            }
            // if (data.column.dataKey === 'commessa'){
            //     cell.text = '';
            // }
            if (data.column.dataKey === 'ecorrispettivo'){
                //data.doc.setFontStyle('bold');
            }
            if (data.column.dataKey === 'epagamento'){
                data.doc.setFontStyle('bold');
            }
            if (data.column.dataKey === 'ucorrispettivo'){
                //data.doc.setFontStyle('bold');
            }
            if (data.column.dataKey === 'upagamento'){
                data.doc.setFontStyle('bold');
            }
            if (data.column.dataKey === 'commessa'){
                //data.doc.setFontStyle('bold');
                // cell.styles.textColor = [255,0,0];
                //cell.styles.halign = 'left';
                cell.text = 'Saldo (cor): ' + cell.text + '/';
                data.cursor.x += 40;
            }
            //console.log("type:", this.reportType);
            if (data.column.dataKey === 'pd' && this.reportType === 'PDC'){
                data.doc.setFontStyle('bold');
                cell.styles.textColor = [255,0,0];
                //cell.styles.halign = 'right';
                cell.text = '(tot): ' + cell.text;
            }
            if (data.column.dataKey === 'pdc' && this.reportType === 'EC'){
                data.doc.setFontStyle('bold');
                cell.styles.textColor = [255,0,0];
                //cell.styles.halign = 'right';
                cell.text = '(tot): ' + cell.text;
            }
            if (data.column.dataKey === 'causale'){
                data.doc.setFontStyle('bold');
                cell.styles.halign = 'left';
            }
            
        }
        if (data.row.raw.id !== ''){
            if (data.column.dataKey === 'documentoAllegato'){
                cell.text =  data.row.raw.documentoAllegato ?  'X' : "";
            }
        }
    }

    doDrawRow(row, data){
        let doc = data.doc;
        if (data.row.raw.id === ''){

            if (data.row.raw.data === 'H1'){
                let height = row.height+15;
                doc.setFillColor(210,210,210);
                doc.rect(data.settings.margin.left, row.y+8, data.table.width, height-18 , 'F');
                doc.setFontStyle('bold');
                doc.setFontSize('14');
                //doc.text(data.row.raw.note, data.settings.margin.left, row.y + height / 2);
                doc.autoTableText(data.row.raw.forma, data.settings.margin.left , row.y + height/2, {
                    halign: 'left',
                    valign: 'middle'
                });
                // doc.setFillColor(0);
                // doc.rect(data.settings.margin.left, row.y + height-1, data.table.width, 1 , 'F');
                data.cursor.y += height;
                return false;
            }
            else if (data.row.raw.data === 'H2'){
                if (data.row.raw.forma === '-'){
                    return false;
                }
                let height = row.height+10;
                doc.setFillColor(255);
                doc.rect(data.settings.margin.left, row.y, data.table.width, height , 'F');
                doc.setFontStyle('bold');
                doc.setFontSize('12');
                //doc.text(data.row.raw.note, data.settings.margin.left, row.y + height / 2);
                doc.autoTableText('  ' + data.row.raw.forma, data.settings.margin.left , row.y + height/2, {
                    halign: 'left',
                    valign: 'middle'
                });
                doc.setFillColor(0);
                let x=data.settings.margin.left;
                while (x < (data.settings.margin.left+data.table.width)){
                    doc.rect(x, row.y + height-1, 2, 1 , 'DF');
                    x += 6;
                }
                data.cursor.y += height;
                return false;
            }
            else if (data.row.raw.data === 'H3'){
                if (data.row.raw.forma === '-'){
                    return false;
                }
                let height = row.height+10;
                doc.setFillColor(255);
                doc.rect(data.settings.margin.left, row.y, data.table.width, height , 'F');
                doc.setFontStyle('bold');
                doc.setFontSize('12');
                //doc.text(data.row.raw.note, data.settings.margin.left, row.y + height / 2);
                doc.autoTableText('    ' + data.row.raw.forma, data.settings.margin.left , row.y + height/2, {
                    halign: 'left',
                    valign: 'middle'
                });
                data.cursor.y += height;
                return false;
            }
            else {
                doc.setFontStyle('bold');
                row.height -= 5;
            }
        }
        else {
            row.height -= 5;
        }
    }

    createPdf(data){


        if (data.title){
            this.setTitle(data.title);
        }

        let srcrows = data.rows;
        let ultimaModifica = data.ultimaModificaInfo;

        if (ultimaModifica){
            this.ultimaModificaText = ' - Ultima modifica ai movimenti selezionati eseguita il ' + Moment(ultimaModifica.modificatoIl).format("DD/MM/YYYY HH:mm") + ' da ' + ultimaModifica.modificatoDa.username;
        }

        let columns = [];
        this.reportType = data.type;

        if(data.type === 'PDC'){
            columns = [
                {title: "ID", dataKey: "id"},
                {title: "Data", dataKey: "data"},
                {title: "Data\nemis.", dataKey: "dataEmissioneDoc"},
                {title: "Doc", dataKey: "documentoAllegato"},
                {title: "Soggetto", dataKey: "soggetto"},
                {title: "Causale", dataKey: "causale"},
                {title: "E\ncorr", dataKey: "ecorrispettivo"},
                {title: "E\nprev.", dataKey: "eonereprev"},
                {title: "E\nfisc.", dataKey: "eonerefisc"},
                {title: "E\nalt", dataKey: "ealtroimp"},
                {title: "E\nrit", dataKey: "eritenuta"},
                {title: "E\npag", dataKey: "epagamento"},
                {title: "U\ncorr", dataKey: "ucorrispettivo"},
                {title: "U\nprev", dataKey: "uonereprev"},
                {title: "U\nfisc", dataKey: "uonerefisc"},
                {title: "U\naltro", dataKey: "ualtroimp"},
                {title: "U\nrit", dataKey: "uritenuta"},
                {title: "U\npag", dataKey: "upagamento"},
                {title: "Tipo\nCassa", dataKey: "tipoCassa"},
                {title: "Commessa", dataKey: "commessa"},
                //{title: "PDC", dataKey: "pdc"},
                {title: "P/D", dataKey: "pd"},
                {title: "Anno", dataKey: "anno"},
                {title: "E/C", dataKey: "ec"},
            ];
        }
        else {
            columns = [
                {title: "ID", dataKey: "id"},
                {title: "Data", dataKey: "data"},
                {title: "Data\nemis.", dataKey: "dataEmissioneDoc"},
                {title: "Doc", dataKey: "documentoAllegato"},
                {title: "Soggetto", dataKey: "soggetto"},
                {title: "Causale", dataKey: "causale"},
                {title: "E\ncorr", dataKey: "ecorrispettivo"},
                {title: "E\nprev.", dataKey: "eonereprev"},
                {title: "E\nfisc.", dataKey: "eonerefisc"},
                {title: "E\nalt", dataKey: "ealtroimp"},
                {title: "E\nrit", dataKey: "eritenuta"},
                {title: "E\npag", dataKey: "epagamento"},
                {title: "U\ncorr", dataKey: "ucorrispettivo"},
                {title: "U\nprev", dataKey: "uonereprev"},
                {title: "U\nfisc", dataKey: "uonerefisc"},
                {title: "U\naltro", dataKey: "ualtroimp"},
                {title: "U\nrit", dataKey: "uritenuta"},
                {title: "U\npag", dataKey: "upagamento"},
                {title: "Tipo\nCassa", dataKey: "tipoCassa"},
                {title: "Commessa", dataKey: "commessa"},
                {title: "PDC", dataKey: "pdc"},
                {title: "P/D", dataKey: "pd"},
                {title: "Anno", dataKey: "anno"},
                //{title: "E/C", dataKey: "ec"},
            ];
        }
        let rows = [];
        srcrows.map((r) => {
            if (r.id === ''){
                if (r.data ==='TP' || r.data === 'TF'){
                    r.commessa = this.formatCurrency(r.commessa);
                    if (this.reportType === 'PDC'){
                        r.pd = this.formatCurrency(r.pd);
                    }
                    else {
                        r.pdc = this.formatCurrency(r.pdc);
                    }
                    r.ecorrispettivo = this.formatCurrency(r.ecorrispettivo);
                    r.epagamento = this.formatCurrency(r.epagamento);
                    r.ucorrispettivo = this.formatCurrency(r.ucorrispettivo);
                    r.upagamento = this.formatCurrency(r.upagamento);
                }
            }
            else {
                r.data = Moment(r.data).format("DD/MM/YY");
                r.dataEmissioneDoc = Moment(r.dataEmissioneDoc).format("DD/MM/YY");
                r.ecorrispettivo = r.ecorrispettivo ? this.formatCurrency(r.ecorrispettivo):'';
                r.eonereprev = r.eonereprev ? this.formatCurrency(r.eonereprev):'';
                r.eonerefisc = r.eonerefisc ? this.formatCurrency(r.eonerefisc):'';
                r.ealtroimp = r.ealtroimp ? this.formatCurrency(r.ealtroimp):'';
                r.eritenuta = r.eritenuta ? this.formatCurrency(r.eritenuta):'';
                r.epagamento = r.epagamento ? this.formatCurrency(r.epagamento):'';
                r.ucorrispettivo = r.ucorrispettivo ? this.formatCurrency(r.ucorrispettivo):'';
                r.uonereprev = r.uonereprev ? this.formatCurrency(r.uonereprev):'';
                r.uonerefisc = r.uonerefisc ? this.formatCurrency(r.uonerefisc):'';
                r.ualtroimp = r.ualtroimp ? this.formatCurrency(r.ualtroimp):'';
                r.uritenuta = r.uritenuta ? this.formatCurrency(r.uritenuta):'';
                r.upagamento = r.upagamento ? this.formatCurrency(r.upagamento):'';
            }
            r.tipoCassa = r.tipoCassa ? r.tipoCassa:'';
            rows.push(r);
            return 0;
        });
        super.createPdf(columns, rows,
            {
                theme: 'plain',
                drawRow: this.doDrawRow,
                drawCell: this.doDrawCell,
                styles: {
                    overflow: 'linebreak',
                    columnWidth: 'wrap',
                    fontSize: 5,
                },
                columnStyles: {
                    pdc: {halign: 'left', columnWidth: 'auto'},
                    documentoAllegato: {halign: 'center', cellWidth: '15'},
                    soggetto: {halign: 'left', columnWidth: '1250'},
                    causale: {halign: 'left', columnWidth: '1000'},
                    ecorrispettivo: {halign: 'right'},
                    eonereprev: {halign: 'right'},
                    eonerefisc: {halign: 'right'},
                    ealtroimp: {halign: 'right'},
                    eritenuta: {halign: 'right'},
                    epagamento: {halign: 'right'},
                    ucorrispettivo: {halign: 'right'},
                    uonereprev: {halign: 'right'},
                    uonerefisc: {halign: 'right'},
                    ualtroimp: {halign: 'right'},
                    uritenuta: {halign: 'right'},
                    upagamento: {halign: 'right'},
                    pd: {halign: 'center'},
                    anno: {halign: 'left', cellWidth: '15'},
                }
            });
    }
}

export default Movimenti;


/** WEBPACK FOOTER **
 ** ./src/pdf/Movimenti.js
 **/